import React from 'react'
import "./SubtitleCustom.css"

/**
 * @typedef {Object} Props
 * @property {string} title Titulo del objeto, por ejemplo:
 * ```js
 * const titulo = "Titulo"
 * const titulo = t("etiqueta.json")
 * ```
 * @property {React.ReactNode} children Elementos adicionales que irán en la esquina derecha del header, por ejemplo:
 * ```js
 * <>
 * <div></div>
 * <ComponenteReact/>
 * </>
 * ```
 */

/**
 * @param {Props}
 * @return {JSX.Element} 
 */
const SubtitleCustom = ({ title, children }) => {

    return (
        <div
            className="subtitleCustom-container"
            xs={12}
            lg={12}
            md={12}
            sm={12}
        >
            <div className="subtitleCustom-subtitleElements">
                <h3 className="subtitleCustom-title">
                    {title}
                </h3>
                {children}
            </div>
        </div>
    )
}

export default SubtitleCustom